<script>
import {gsap} from "gsap";
import {SplitText} from "gsap/SplitText";

gsap.registerPlugin(SplitText)
export default {
  name: "TakeaBreakStep1",
  props: {
    formData: {
      type: Object,
      default: () => ({}),
    },
    mapVisible: {},
  },
  watch: {
    mapVisible(newVal) {

      if (newVal === true) {
        this.$nextTick(() => {

        });
      }
    },
  },
  data() {
    return {
      selectedImage: null
    }
  },
  beforeMount() {
    this.getAvatar(this.formData.avatar);
    this.$emit('goBack', 0);
  },
  mounted() {
    this.initAnimation();
  },
  methods: {
    getAvatar(avatar) {
      this.selectedImage = require(`@/assets/img/avatare/${avatar}.webp`);
    },
    launchTimeStep1() {
      this.$emit('nextStep', 'launchTimeStep1');
    },
    eventStep1() {
      this.$emit('nextStep', 'eventStep1');
    },
    closeOverlay() {
      this.$emit('closeOverlay')
    },
    nextStep(data) {
      this.$emit('nextStep', data)
    },
    initAnimation() {

      var mySplitText = new SplitText(this.$refs.speechbubble_anim.children, {type: "words"});
      var mySplitText2 = new SplitText(this.$refs.speechbubble_anim2.children, {type: "words"});
      var splitTextTimeline = gsap.timeline();
      var splitTextTimeline2 = gsap.timeline();
      mySplitText.split({type: "chars, words"})
      mySplitText2.split({type: "chars, words"})
      splitTextTimeline
          .from(this.$refs.takeabreakElement1, {
            y: -100,
            autoAlpha: 0
          })
          .from(mySplitText.chars, {
            duration: 0.6,
            // display:"none",

            visibility: "hidden",
            stagger: 0.016
          })
          .fromTo(this.$refs.button1, {
            y: 20,
            autoAlpha: 0
          }, {
            y: 0,
            autoAlpha: 1
          });
      splitTextTimeline2
          .from(this.$refs.takeabreakElement2, {
            y: -100,
            autoAlpha: 0
          })
          .from(mySplitText2.chars, {
            duration: 0.6,
            // display:"none",

            visibility: "hidden",
            stagger: 0.016
          })
          .fromTo(this.$refs.button2, {
            y: 20,
            autoAlpha: 0
          }, {
            y: 0,
            autoAlpha: 1
          });
    },
  }
}
</script>

<template>

  <div ref="smallPopup" id="sidebarpopup" class="popup overlay smallerpopup"
       data-model="">
    <div ref="popup_wrapper__smaller" class="popup_wrapper popup_wrapper__smaller">
               <span @click="closeOverlay" class="popup_closepopup closeoverlay">
<svg xmlns="http://www.w3.org/2000/svg" width="22.945" height="22.945" viewBox="0 0 22.945 22.945">
  <g id="Gruppe_7895" data-name="Gruppe 7895" transform="translate(1.414 1.414)">
    <line id="Linie_4" data-name="Linie 4" x2="20.117" y2="20.117" transform="translate(0 0)" fill="none" stroke="#fff"
          stroke-linecap="round" stroke-width="2"/>
    <line id="Linie_5" data-name="Linie 5" x2="20.117" y2="20.117" transform="translate(20.117 0) rotate(90)"
          fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2"/>
  </g>
</svg>
</span>
      <span @click="nextStep(0)" class="popup_prevstep prevstep">
        <img style="transform: scaleX(-1);" src="@/assets/img/arrow-right.svg">
      </span>
      <div class="popup_content popup_content_right">
        <div class="popup_content takeabreak_contentwrapper">
          <div ref="takeabreakElement1" class="form-content takeabreak_content" style="">
            <div class="takeabreak_content_imgwrapper">
              <img src="@/assets/img/female.png"/>
              <img src="@/assets/img/gedankenblase.png"/>
            </div>
            <div ref="speechbubble_anim" class="takeabreak_content__textwrapper">
              <p class="speechbubble_anim">{{ $t("takeaBreak.breakIntroStep1part1")}}<br/>
                {{ $t("takeaBreak.breakIntroStep1part2")}}</p>
            </div>
            <a ref="button1" @click="launchTimeStep1" class="button avatarthumb_wrapper" href="#"><img
                class="avatarthumb" :src="selectedImage"/><span>      {{ $t("takeaBreak.breakIntroStep1response")}}</span>
              <img src="@/assets/img/arrow-right.svg">
            </a>
          </div>
          <div ref="takeabreakElement2" class="form-content takeabreak_content" style="">
            <div class="takeabreak_content_imgwrapper">
              <img src="@/assets/img/male.png"/>
              <img src="@/assets/img/gedankenblase.png"/>
            </div>
            <div ref="speechbubble_anim2" class="takeabreak_content__textwrapper">
              <p class="speechbubble_anim">{{ $t("takeaBreak.breakIntroStep1_Evening")}}</p>
            </div>
            <a ref="button2" @click="eventStep1" class="button avatarthumb_wrapper" href="#"><img class="avatarthumb"
                                                                                                  :src="selectedImage"/><span>
              {{ $t("takeaBreak.breakIntroStep1response_evening")}}
            </span><img
                src="@/assets/img/arrow-right.svg"></a>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>

<style lang="scss" scoped>

</style>
